var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title-box",style:({ backgroundColor: '#ffac44' })},[_c('h3',[_vm._v(_vm._s(_vm.title)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.title2))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }